import { CoreMenu } from '@core/types';

export const getMenu = (isAdmin: boolean): CoreMenu[] => {
  // 1. Herkesin (Admin olmayanların da) görebileceği ortak sayfalar
  const commonChildren: CoreMenu[] = [
    {
      id: 'board',
      title: 'Scrum board',
      translate: 'Menu.Board',
      type: 'item',
      icon: 'pie-chart',
      url: 'dashboard/board'
    },
    {
      id: 'ticket',
      title: 'Bilet',
      translate: 'Menu.Ticket',
      icon: 'info',
      type: 'collapsible',
      children: [
        {
          id: 'save-ticket',
          title: 'Bilet ekle',
          translate: 'Menu.AddTicket',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/save-ticket'
        },
        {
          id: 'TicketList',
          title: 'Bilet listesi',
          translate: 'Menu.TicketList',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/ticket-list'
        }
      ]
    },
    {
      id: 'takeLeave',
      title: 'İzin al',
      translate: 'Menu.TakeLeave',
      icon: 'clock',
      type: 'collapsible',
      children: [
        {
          id: 'save-take-leave',
          title: 'İzin günü ekle',
          translate: 'Menu.AddTakeLeave',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/save-take-leave'
        },
        {
          id: 'take-leave-list',
          title: 'İzin günü listesi',
          translate: 'Menu.TakeLeaveList',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/take-leave-list'
        }
      ]
    }
  ];

  // 2. Sadece Admin'in görebileceği sayfalar
  const adminChildren: CoreMenu[] = [
    {
      id: 'dashboard',
      title: 'Gösterge Paneli',
      translate: 'Menu.Dashboard',
      type: 'item',
      icon: 'pie-chart',
      url: 'dashboard/default'
    },
    {
      id: 'employeeBoard',
      title: 'Employee board',
      translate: 'Menu.EmployeeBoard',
      type: 'item',
      icon: 'pie-chart',
      url: 'dashboard/employee-board'
    },
    {
      id: 'board',
      title: 'Scrum board',
      translate: 'Menu.Board',
      type: 'item',
      icon: 'pie-chart',
      url: 'dashboard/board'
    },
    {
      id: 'ticket',
      title: 'Bilet',
      translate: 'Menu.Ticket',
      icon: 'info',
      type: 'collapsible',
      children: [
        {
          id: 'save-ticket',
          title: 'Bilet ekle',
          translate: 'Menu.AddTicket',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/save-ticket'
        },
        {
          id: 'TicketList',
          title: 'Bilet listesi',
          translate: 'Menu.TicketList',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/ticket-list'
        }
      ]
    },
    {
      id: 'takeLeave',
      title: 'İzin al',
      translate: 'Menu.TakeLeave',
      icon: 'clock',
      type: 'collapsible',
      children: [
        {
          id: 'save-take-leave',
          title: 'İzin günü ekle',
          translate: 'Menu.AddTakeLeave',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/save-take-leave'
        },
        {
          id: 'take-leave-list',
          title: 'İzin günü listesi',
          translate: 'Menu.TakeLeaveList',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/take-leave-list'
        }
      ]
    },
    {
      id: 'customer',
      title: 'Müşteri',
      translate: 'Menu.Customer',
      icon: 'info',
      type: 'collapsible',
      children: [
        {
          id: 'save-customer',
          title: 'Müşteri ekle',
          translate: 'Menu.AddCustomer',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/save-customer'
        },
        {
          id: 'CustomerList',
          title: 'Müşteri listesi',
          translate: 'Menu.CustomerList',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/customer-list'
        },
        {
          id: 'CustomerInformation',
          title: 'Müşteri bilgileri',
          translate: 'Menu.CustomerInformation',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/customer-information'
        }
      ]
    },
    {
      id: 'projects',
      title: 'Projeler',
      translate: 'Menu.projects',
      type: 'collapsible',
      icon: 'pie-chart',
      children: [
        {
          id: 'projects',
          title: 'Proje Detayları',
          translate: 'Menu.projects',
          type: 'item',
          icon: 'file-plus',
          url: 'dashboard/project-detail-list'
        },
        {
          id: 'projectCompanyList',
          title: 'Müşteri proje listesi',
          translate: 'Menu.projectCompanyList',
          type: 'item',
          icon: 'file-text',
          url: 'dashboard/project-company-list'
        }
      ]
    },
    {
      id: 'reports',
      title: 'Raporlar',
      translate: 'Menu.Reports',
      type: 'collapsible',
      icon: 'file',
      children: [
        {
          id: 'ticketReports',
          title: 'Bilet Raporu',
          translate: 'Menu.TicketReports',
          icon: 'file-text',
          type: 'collapsible',
          children: [
            {
              id: 'openTicketList',
              title: 'Açılan Bilet Raporu',
              translate: 'Menu.OpenTicketList',
              icon: 'file-text',
              type: 'item',
              url: 'dashboard/open-ticket-list'
            },
            {
              id: 'closedTicketList',
              title: 'Kapanan Bilet Raporu',
              translate: 'Menu.ClosedTicketList',
              icon: 'file-text',
              type: 'item',
              url: 'dashboard/closed-ticket-list'
            },
            {
              id: 'assignedEmployeeCountList',
              title: 'Atanan Bilet Raporu',
              translate: 'Menu.assignedEmployeeCountList',
              icon: 'file-text',
              type: 'item',
              url: 'dashboard/assigned-employee-count-list'
            },
            {
              id: 'clientOpenTicket',
              title: 'Müşteri Açık Bilet',
              translate: 'Menu.assignedEmployeeCountList',
              icon: 'file-text',
              type: 'item',
              url: 'dashboard/client-open-ticket'
            },
            {
              id: 'employeeCloseTicket',
              title: 'Çözülen Bilet Raporu',
              translate: 'Menu.employeeCloseTicket',
              icon: 'file-text',
              type: 'item',
              url: 'dashboard/employee-close-ticket'
            }
          ]
        }
      ]
    },
    {
      id: 'meetingRoomSchedule',
      title: 'Toplantı odası programı',
      translate: 'Menu.MeetingRoomSchedule',
      type: 'item',
      icon: 'clock',
      url: 'dashboard/meeting-room-schedule'
    },
    {
      id: 'calendar',
      title: 'Takvim',
      translate: 'Menu.Calendar',
      icon: 'circle',
      type: 'item',
      url: 'dashboard/calendar'
    },
    {
      id: 'officeEquipment',
      title: 'Ofis ekipman',
      translate: 'Menu.OfficeEquipment',
      icon: 'user',
      type: 'collapsible',
      children: [
        {
          id: 'save-office-equipment',
          title: 'Ofis ekipman ekle',
          translate: 'Menu.AddOfficeEquipment',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/save-office-equipment'
        },
        {
          id: 'office-equipment-list',
          title: 'Ofis ekipman listesi',
          translate: 'Menu.OfficeEquipmentList',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/office-equipment-list'
        }
      ]
    },
    {
      id: 'basicInformation',
      title: 'Temel bilgiler',
      translate: 'Menu.BasicInformation',
      icon: 'info',
      type: 'collapsible',
      children: [
        {
          id: 'department',
          title: 'Departman',
          translate: 'Menu.Department',
          type: 'item',
          icon: 'folder',
          url: 'dashboard/department'
        },
        {
          id: 'meetingRoom',
          title: 'Toplantı odası',
          translate: 'Menu.MeetingRoom',
          type: 'item',
          icon: 'clock',
          url: 'dashboard/meeting-room'
        },
        {
          id: 'project',
          title: 'Proje',
          translate: 'Menu.Project',
          type: 'item',
          icon: 'type',
          url: 'dashboard/project'
        },
        {
          id: 'tag',
          title: 'Etiket',
          translate: 'Menu.Tag',
          type: 'item',
          icon: 'type',
          url: 'dashboard/tag'
        },
        {
          id: 'ticketType',
          title: 'Bilet tipi',
          translate: 'Menu.TicketType',
          type: 'item',
          icon: 'type',
          url: 'dashboard/ticket-type'
        },
        {
          id: 'contactType',
          title: 'İletişim Türü',
          translate: 'Menu.ContactType',
          type: 'item',
          icon: 'type',
          url: 'dashboard/contact-type'
        },
        {
          id: 'businessRole',
          title: 'Çalışan pozisyonu',
          translate: 'Menu.BusinessRole',
          type: 'item',
          icon: 'type',
          url: 'dashboard/business-role'
        },
        {
          id: 'officeEquipmentType',
          title: 'Ofis ekipman türü',
          translate: 'Menu.OfficeEquipmentType',
          type: 'item',
          icon: 'map-pin',
          url: 'dashboard/office-equipment-type'
        },
        {
          id: 'officeEquipmentBrand',
          title: 'Ofis ekipman markası',
          translate: 'Menu.OfficeEquipmentBrand',
          type: 'item',
          icon: 'map-pin',
          url: 'dashboard/office-equipment-brand'
        },
        {
          id: 'officeEquipmentModel',
          title: 'Ofis ekipman modeli',
          translate: 'Menu.OfficeEquipmentModel',
          type: 'item',
          icon: 'map-pin',
          url: 'dashboard/office-equipment-model'
        },
        {
          id: 'CargoIntegration',
          title: 'Kargo entegrasyon',
          translate: 'Menu.CargoIntegration',
          type: 'item',
          icon: 'flag',
          url: 'dashboard/cargo-integration'
        },
        {
          id: 'ERP',
          title: 'ERP',
          translate: 'Menu.ERP',
          type: 'item',
          icon: 'flag',
          url: 'dashboard/erp'
        },
        {
          id: 'Module',
          title: 'Modül',
          translate: 'Menu.Module',
          type: 'item',
          icon: 'flag',
          url: 'dashboard/module'
        },
        {
          id: 'VirtualPos',
          title: 'Sanal pos',
          translate: 'Menu.VirtualPos',
          type: 'item',
          icon: 'flag',
          url: 'dashboard/virtual-pos'
        },
        {
          id: 'country',
          title: 'Ülke',
          translate: 'Menu.Country',
          type: 'item',
          icon: 'flag',
          url: 'dashboard/country'
        },
        {
          id: 'province',
          title: 'il',
          translate: 'Menu.Province',
          type: 'item',
          icon: 'map',
          url: 'dashboard/province'
        },
        {
          id: 'district',
          title: 'ilçe',
          translate: 'Menu.District',
          type: 'item',
          icon: 'map-pin',
          url: 'dashboard/district'
        }
      ]
    },
    {
      id: 'employee',
      title: 'Çalışanlar',
      translate: 'Menu.Employees',
      icon: 'user',
      type: 'collapsible',
      children: [
        {
          id: 'save-employee',
          title: 'Çalışan Ekle',
          translate: 'Menu.AddEmployee',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/save-employee'
        },
        {
          id: 'employee-list',
          title: 'Çalışanlar',
          translate: 'Menu.EmployeeList',
          icon: 'circle',
          type: 'item',
          url: 'dashboard/employee-list'
        }
      ]
    },
    {
      id: 'applicationSetting',
      title: 'Uygulama Ayarı',
      translate: 'Menu.ApplicationSetting',
      type: 'item',
      icon: 'settings',
      url: 'dashboard/application-setting'
    }
  ];

  // 3. Menüyü yetkiye göre birleştir ve döndür
  return [
    {
      id: 'apps',
      type: 'section',
      title: '',
      translate: '',
      icon: 'package',
      children: isAdmin ? [...adminChildren] : [...commonChildren]
    }
  ];
};